<template>
  <div id="app">
    <div class="app-container">
      <router-view class="main-content" />
      <div class="bottom-nav" v-if="showBottomNav">
        <div 
          class="nav-item" 
          :class="{ active: currentTab === 'home' }"
          @click="switchTab('home')"
        >
          <i class="el-icon-location-outline"></i>
          <span>首页</span>
        </div>
        <div 
          class="nav-item" 
          :class="{ active: currentTab === 'user' }"
          @click="switchTab('user')"
        >
          <i class="el-icon-user"></i>
          <span>用户中心</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentTab: 'home'
    }
  },
  computed: {
    showBottomNav() {
      return this.$route.meta.showBottomNav !== false
    }
  },
  methods: {
    switchTab(tab) {
      this.currentTab = tab
      if (tab === 'home') {
        this.$router.push('/')
      } else if (tab === 'user') {
        this.$router.push('/user')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.app-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.bottom-nav {
  height: 60px;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 20px;
  
  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;
    cursor: pointer;
    transition: all 0.3s;
    
    i {
      font-size: 24px;
      margin-bottom: 4px;
    }
    
    span {
      font-size: 12px;
    }
    
    &.active {
      color: $tieta-red;
    }
  }
}
</style>